import React, { useState } from "react";
import { Modal, Spinner } from "react-bootstrap";
import { setUser } from "../../../redux/reducers/userSlice";
import { useDispatch } from "react-redux";
import { getWeb3 } from "../../../util/getWeb3.js";
import { useHistory } from "react-router-dom";
import "./style.css";
import { toastMessage } from "../../../components/common/toast";
import { LogInUser } from "../../../services/authService";
function LoginModal({ openModal, HideModal, OpenModal1, setAddress }) {
  const dispatch = useDispatch();
  const history = useHistory();
  const [isSubmitting, setSubmitting] = useState(false);
  const handleConnectedWallet = async () => {
    setSubmitting(true);
    let web3 = await getWeb3(null);
    let obj = {};
    if (!web3) {
      setSubmitting(false);
    }
    if (web3) {
      let add = await web3?.eth.getAccounts();
      if (add && add?.length > 0) {
        obj["walletaddress"] = add[0];
      }
      await LogInUser(obj)
        .then((res) => {
          if (res.statusText === "OK") {
            let resp = {
              isLoggedIn: true,
              token: res.data.token,
              user: res.data.user,
              books: res.data.books,
            };
            setSubmitting(false);
            dispatch(setUser(resp));
            history.push(`/home/${res.data.user._id}`);
            HideModal();
            toastMessage("User Logged In Successfully", "success");
          } else if (res.status == 201) {
            setAddress(add);
            setSubmitting(false);
            HideModal();
            OpenModal1();
          }
        })
        .catch((error) => {
          setSubmitting(false);
          toastMessage(error.response.data, "error");
        });
    }
  };
  return (
    <Modal
      size="lg"
      backdrop="static"
      show={openModal}
      onHide={HideModal}
      centered
    >
      <button
        type="button"
        className="close custom-modal-close"
        onClick={HideModal}
      >
        <span aria-hidden="true">&times;</span>
      </button>
      <div className="login-modal-body">
        <p className="login-heading">Welcome! Let's begin with</p>
        <p className="login-heading">your wallet.</p>
        <button
          className="connect-login-btn"
          disabled={isSubmitting}
          onClick={handleConnectedWallet}
        >
          {isSubmitting ? (
            <Spinner animation="grow" size="sm" />
          ) : (
            <p className="mb-0">Connect Wallet</p>
          )}
        </button>
        <p className="login-link">
          <u onClick={handleConnectedWallet}>First Time Setting Up A Wallet?</u>
        </p>
      </div>
    </Modal>
  );
}

export default LoginModal;
